import React from 'react'
import { Link } from 'react-router-dom'
import Router from '../../../../router'

import Recaptcha from 'react-google-recaptcha';

import {
    Container,
    Form,
    Title,
    SectionRow,
    SectionInput,
    Label,
    ContainerInput,
    Input,
    Span,
    SectionBtn,
    BtnSubmit,
    SpanLink,
    SubtitleCustom,
    LabelCustom,
    ContainerLogin,
    CustomInput
} from './styles'

import { Title as TitleBold } from '../LoginForm/styles';

import { useTranslation } from 'react-i18next'
import { InputAdornment } from '@mui/material';
import KeyIcon from '@mui/icons-material/Key';

export const PasswordResetForm = ({
    colors,
    form,
    setForm,
    isLoading,
    isRedirect,
    handleSubmit,
    handleChange,
    messageResponse,
    recaptchaRef
}) => {
    const { t } = useTranslation();

    const getLoginIcon = () => {
        if (colors?.loginIconUrl === null || colors?.loginIconUrl === undefined || colors?.loginIconUrl === "") {
            return (
                <img src='cenit-logo.png' width={300} alt='logo' />
            )
        }

        return (colors?.loginIconUrl !== null && colors?.loginIconUrl !== "" && colors?.loginIconUrl !== undefined) ?
            <img src={`${Router.apiBaseUrl}/${colors.loginIconUrl.toString()}`} width={300} alt='logo' />
            : null
    }

    const handleRecaptchaVerify = (response) => {
        setForm({ ...form, reCaptchaToken: response })
    };

    return (
        <Container>
            <Form onSubmit={handleSubmit}>
                {getLoginIcon()}
                <TitleBold>{(colors?.title !== null && colors?.title !== "" && colors?.title !== undefined ? colors.title : t('login.titleApp'))}</TitleBold>
                <ContainerLogin>
                    <SubtitleCustom>{t('password.passwordReset')}</SubtitleCustom>
                    {!isRedirect && (
                        <>
                            <SectionRow>
                                <SectionInput>
                                    <LabelCustom>{t('password.stepResetPassword')}</LabelCustom>
                                    <CustomInput
                                        name='password'
                                        label={t('password.newPassword')}
                                        type={'password'}
                                        value={form.password}
                                        variant="outlined"
                                        onChange={(e) => handleChange(e, 'password')}
                                        disabled={isLoading}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <KeyIcon sx={{ color: colors.navbarColor }}/>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </SectionInput>
                            </SectionRow>
                            <SectionRow>
                                <SectionInput>
                                    <CustomInput
                                        name='confirmPassword'
                                        label={t('password.confirmPassword')}
                                        type={'password'}
                                        variant="outlined"
                                        value={form.confirmPassword}
                                        onChange={(e) => handleChange(e, 'confirmPassword')}
                                        disabled={isLoading}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <KeyIcon sx={{ color: colors.navbarColor }}/>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </SectionInput>
                            </SectionRow>
                            {messageResponse !== '' &&
                                <SectionRow>
                                    <SectionInput>
                                        <Span color={isRedirect}>{messageResponse}</Span>
                                    </SectionInput>
                                </SectionRow>
                            }

                            {process.env.REACT_APP_CAPTCHA !== undefined && !isRedirect &&
                                <SectionRow>
                                    <div style={{ margin: '0 auto' }}>
                                        <Recaptcha ref={recaptchaRef} sitekey={process.env.REACT_APP_CAPTCHA} onChange={handleRecaptchaVerify} />
                                    </div>
                                </SectionRow>
                            }
                        </>
                    )}
                    <SectionBtn>
                        {isRedirect &&
                            <Link to={Router.appLogin} disabled={isLoading}>
                                <SpanLink>{t('password.goToLogin')}</SpanLink>
                            </Link>
                        }
                        {!isRedirect && (
                            <BtnSubmit type='submit' disabled={isLoading || form.reCaptchaToken === null}>{t('password.savePassword')}</BtnSubmit>
                        )}
                    </SectionBtn>
                    
                </ContainerLogin>
            </Form>
        </Container>
    )
}